module.exports = __webpack_public_path__ + "img/payment_expired.753dfba5.png";